<template>
  <div class="wasenbunka">
    <div class="main_image" v-if="this.$route.params.lang === 'ja'">
			<img src="image/sample.png">
			<span>内海船<br>内田佐七家</span>
		</div>
		<div class="main_image" v-else-if="this.$route.params.lang === 'en'">
			<img src="image/sample.png">
			<span>Utsumi-bune<br>The Uchida Sashichi Residence</span>
		</div>
		<div class="content" v-if="this.$route.params.lang === 'ja'">
			<div class="sitearea">
				<div class="intro">
					<h2>
						<ruby>内海船<rt>うつみぶね</rt></ruby>とは
					</h2>
					<p>江戸時代後期から明治時代にかけて、南知多町内海を中心に、知多半島南部地域の廻船主で構成された「戎講組合（えびすこうくみあい）」に加入した廻船は、「内海船」と呼ばれました。戎講組合は、遅くとも天明４年(1784)には結成されていたことがわかっており、最盛期には約100艘の船が加入していました。内海船の活動範囲は、江戸から瀬戸内海東半分の間で、米を主な積荷とし、瀬戸内や上方は、塩、畳表など、江戸やその周辺では魚を原料とする肥料や大豆などを運びました。内海船は生産地で商品を買い取り、消費地でその商品を売って利益をあげる「買積（かいづみ）」という商いを得意としました。</p>
				</div>
				<div class="about_ship fix">
					<p class="left img">
						<img src="image/sample.png">
					</p>
					<div class="right txt">
						<h3>船内について</h3>
						<p>船室は船の後部にあり、「屋倉（やぐら）」と言われました。ここには船頭の部屋のほか、神棚や仏壇などが設置された部分や、炊事場、居室などの部分に分かれていました。また、帆を吊るした「帆桁（ほげた）」と呼ばれる長大な部材や碇などの重量物を上げ下ろしするために使用した「轆轤」と呼ばれる綱の巻き取り装置もこの部分に設置されました。</p>
						<p><a href="https://minamichita-museum.com/wasen/ship.html">詳しく見る</a></p>
					</div>
				</div>
				<div class="about_ship fix">
					<p class="right img">
						<img src="image/sample.png">
					</p>
					<div class="left txt">
						<h3>町内に残る史跡</h3>
						<p>町内には、内海を中心に内海船に関わる史跡がたくさん残されています。特に内海川河口の東端、西端地区には、船主や戎講組合と密接な関係にあった寺社が多くあります。</p>
						<p><a href="https://minamichita-museum.com/wasen/shiseki.html">詳しく見る</a></p>
					</div>
				</div>
				<div class="about_ship fix">
					<p class="left img">
						<img src="image/sample.png">
					</p>
					<div class="right txt">
						<h3>古文書</h3>
						<p>内海船の活動は残された古文書から明らかにされました。日本福祉大学知多半島総合研究所は、これらの古文書をもとに長年にわたって研究しています。</p>
						<p><a href="https://minamichita-museum.com/wasen/document.html">詳しく見る</a></p>
					</div>
				</div>
			</div>
		</div>
		<div class="content" v-else-if="this.$route.params.lang === 'en'">
			<div class="sitearea">
				<div class="intro">
					<h2>
						What Is an Utsumi-bune?
					</h2>
					<p>From the second half of the Edo period through the Meiji period, trading ships from the southern part of the Chita Peninsula(Utsumi, Minamichita in particular)were called "Utsumi-bune". Utsumi-bune operated between Edo (Tokyo) and the Seto Inland Sea. Their main cargo was rice, and they also carried soybeans as well as salt, tatami mats, and fish to be used as an ingredient in fertilizer.<br>The ships would purchase these goods in the areas where they were produced, and then earn a profit by exploiting the price difference in the places where they were consumed.</p>
				</div>
				<div class="about_ship fix">
					<p class="left img">
						<img src="image/sample.png">
					</p>
					<div class="right txt">
						<h3>Ship Cabins</h3>
						<p>A window called "Monomi" for confirming the state of the bottom of the ship is provided just behind the mast.The ship's shrine and altar were put on a starboard side of Monomi and a cupboard on a port side.The Ship Nameplate was hanged in the upper part of the Monomi.</p>
						<p><a href="https://minamichita-museum.com/wasen/ship.html">See more</a></p>
					</div>
				</div>
				<div class="about_ship fix">
					<p class="right img">
						<img src="image/sample.png">
					</p>
					<div class="left txt">
						<h3>History That Survives in Minamichita</h3>
						<p>A great deal of history connected with the Utsumi-bune survives in Minamichita, particularly in Utsumi.Especially around the Higashibata and Nishibata regions of the Utsumi River delta, there are numerous temples and shrines that were closely connected with shipowners and the Ebisuko Association.</p>
						<p><a href="https://minamichita-museum.com/wasen/shiseki.html">See more</a></p>
					</div>
				</div>
				<div class="about_ship fix">
					<p class="left img">
						<img src="image/sample.png">
					</p>
					<div class="right txt">
						<h3>Historical Documents</h3>
						<p>The activities of the Utsumi-bune are made known to us through some 10,000 historical documents that survive to this day, particularly those stored at the Uchida Sashichi Residence. The Institute of Chitahanto Regional Development, Nihon Fukushi University has been studying these documents for many years.</p>
						<p><a href="https://minamichita-museum.com/wasen/document.html">See more</a></p>
					</div>
				</div>
			</div>
		</div>
  </div>
</template>

<style lang="less">
  //mediaquery設定
  @screen-xs-max: 660px; //スマホ
  @screen-sm-max: 768px; //ipad
	@screen-lg-max: 1200px; //ブラウザサイズ1200px以下
  .screen-xs(@rules) {
    @media (max-width: @screen-xs-max) { @rules(); } 
  }
  .screen-sm(@rules) {
    @media (max-width: @screen-sm-max) { @rules(); }
  }
  .screen-lg(@rules) {
    @media (max-width: @screen-lg-max) { @rules(); }
	}
	
	.wasenbunka{
		text-align: left;
		.screen-sm({
			margin-top: 55px;
		});
		.main_image{
			margin-bottom: 50px;
			position: relative;
			.screen-xs({
				margin-bottom: 30px;
			});
			img{
				width: 100%;
				display: block;
    		overflow: hidden;
			}
			/*span{
				display: block;
    		margin: -10% auto 0 auto !important;
				width: 100%;
				color: #fff;
				font-size: 35px;
				line-height: 1.3;
			}*/
			span{
				width:1200px;
				bottom: 0;
				left: 50%;
				-webkit-transform: translate(-50%,-50%);
				-moz-transform: translate(-50%,-50%);
				-ms-transform: translate(-50%,-50%);
				-o-transform: translate(-50%,-50%);
				transform: translate(-50%,-50%);
				color: #fff;
				font-size: 35px;
				line-height: 1.3;
				position: absolute;
				.screen-lg({
					width: 90%;
				});
				.screen-sm({
					font-size: 24px;
				});
				.screen-xs({
					bottom: -20px;
				});
			}
		}
		.content{
			width: 100%;
			.intro {
    		padding: 0 70px;
				margin: 5% 0 90px;
				.screen-sm({
					padding: 0;
				});
				.screen-xs({
					margin: 5% 0 70px;
				});
				h2{
					margin-bottom: 45px;
    			width: 100%;
					color: #3f698f;
    			font-size: 28px;
    			font-weight: normal;
					text-align: center;
					.screen-xs({
						margin-bottom: 30px;
					});
				}
				p{
					font-size: 18px;
					.screen-xs({
						font-size: 14px;
					});
				}
			}
			.about_ship{
				margin-bottom: 90px;
				.screen-xs({
					margin-bottom: 70px;
				});
				.left{
					float: left;
					.screen-xs({
						float: none;
					});
				}
				.right{
					float: right;
					.screen-xs({
						float: none;
					});
				}
				.img{
					width: 62.5%;
					.screen-xs({
						margin: 0 -6% 18px;
						width: 112%;
					});
				}
				.txt{
					width: 37.5%;
					box-sizing: border-box;
					.screen-xs({
						width: 100%;
					});
				}
				.left,.right{
					img{
						width: 100%;
					}
					h3{
						margin-bottom: 20px;
						color: #666; 
						font-size: 26px;
						font-weight: normal;
						text-align: center;
					}
					p{
						font-size: 16px;
						&:nth-of-type(1){
							padding: 0 62px 0 62px;
							.screen-sm({
								padding: 0 10%;
							});
							.screen-xs({
								padding: 0;
								font-size: 14px;
							});
						}
						&:nth-of-type(2){
						  text-align: center;
							margin-top: 10%;
							a{
								margin: 0 auto;
								padding: 21px 0 19px;
								width: 200px;
								height: 65px;
								background: #3f698f;
								box-sizing: border-box;
								color: #ffffff;
								display: block;
								text-align: center;
								text-decoration: none;
								position: relative;
								&::after{
									content: '';
									width: 6px;
									height: 6px;
									border: 0px;
									border-top: solid 2px #FFF;
									border-right: solid 2px #FFF;
									-ms-transform: rotate(45deg);
									-webkit-transform: rotate(45deg);
									transform: rotate(45deg);
									position: absolute;
									top: 42%;
									right: 15%;
									.screen-xs({
										border-top: solid 1px #FFF;
										border-right: solid 1px #FFF;
										top: 44%;
                	});
								}
							}
						}
					}
				}
			}
		}
	}
</style>

<script>
  export default {
    name: 'wasenbunka'
  }
</script>